<div :class="className" class="my-2 w-full">
  <input type="text" :name="name"
    class="bg-qr_color-gray_3 h-12 px-2.5 py-2 text-qr_color-gray peer rounded-qr_input_radius block w-full border-0 focus:ring-0 focus:border-transparent"
    :value="value" :placeholder="placeHolder" @change="onUpdateValue" v-on="inputListeners"
    :hasValidators="hasValidators" />
  <span class="text-qr_color-error">{{errorMessage}}</span>
</div>